import { render } from "./sTable.vue?vue&type=template&id=6013b9e6&scoped=true"
import script from "./sTable.vue?vue&type=script&lang=js"
export * from "./sTable.vue?vue&type=script&lang=js"

import "./sTable.vue?vue&type=style&index=0&id=6013b9e6&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\zh-frontend\\microfront-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6013b9e6"]])

export default __exports__